export default {
  namespaced: true,
  state: {
    cartItem: [],
    customer: null,
    selectCartId: null,
    inventoryStore: [],
    registryDetail: {},
    equalValues: {},
  },
  getters: {
    getCartItem: state => state.cartItem,
    getCustomer: state => state.customer,
    getSelectCartId: state => state.selectCartId,
    getInventoryStore: state => state.inventoryStore,
    getRegistryDetail: state => state.registryDetail,
    getEqualValue: state => inventoryId => {
      return state.equalValues?.[inventoryId] ?? false
    },
  },
  mutations: {
    SET_EQUAL_VALUE(state, { inventoryId, value }) {
      state.equalValues[inventoryId] = value
    },
    CLEAR_EQUAL_VALUE(state, inventoryId) {
      delete state.equalValues[inventoryId]
    },
    CLEAR_ALL_EQUAL_VALUES(state) {
      state.equalValues = {}
    },
    SET_CART_ITEM(state, payload) {
      state.cartItem = payload
    },
    SET_CUSTOMER(state, payload) {
      state.customer = payload
    },
    PUSH_CART_ITEM(state, payload) {
      state.cartItem.unshift(payload)
    },
    SET_SELECT_CART(state, payload) {
      state.selectCartId = payload
    },
    SET_INVENTORY_STORE(state, payload) {
      state.inventoryStore = payload
    },
    RESET_CART_DATA(state) {
      state.cartItem = []
      state.customer = null
      state.selectCartId = null
    },
    RESET_CUSTOMER(state) {
      state.customer = null
    },
    SET_REGISTRY_DETAIL(state, payload) {
      state.registryDetail = payload
    },
  },
  actions: {
    ADD_CART_ITEM: ({ commit }, payload) => {
      commit('PUSH_CART_ITEM', payload)
      commit('SET_SELECT_CART', payload.inventory_id)
    },
    REMOVE_SELECT_CART: ({ commit, getters }, indexToRemove) => {
      const cartItem = [...getters.getCartItem]

      cartItem.splice(indexToRemove, 1)
      commit('SET_CART_ITEM', cartItem)
    },
    SELECT_FIRST_ITEM: ({ commit, getters }) => {
      const cartItem = getters.getCartItem
      if (cartItem.length) {
        commit('SET_SELECT_CART', cartItem[0].inventory_id)
      }
    },
  },
}
